/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var MemberRole;
(function (MemberRole) {
    MemberRole["OWNER"] = "OWNER";
    MemberRole["ADMIN"] = "ADMIN";
    MemberRole["MEMBER"] = "MEMBER";
})(MemberRole || (MemberRole = {}));
